import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Plan_bg from "./images/Plan_Bg.webp";
import { Ottslider } from "./components/Ottslider";

export const IptvPlans = () => {
  const { slug } = useParams();
  const [plans, setPlans] = useState([]);

  // Decode HTML
  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const createMarkup = (content) => {
    return { __html: decodeHTML(content || "") };
  };

  // Fetch plans
  useEffect(() => {
    let url = window.weburl + `api/plans.php?catID=7`;

    if (slug) {
      url += `&pid=${slug}`;
    }

    axios
      .get(url)
      .then((res) => {
        if (res.data?.data) {
          setPlans(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  }, [slug]);

  return (
    <>
      <Header />

      <section className="pt-50 pb-50">
        <div className="container">
          <section id="Broadband" className="blckarrow">
            <div className="container">
              <div className="row">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                  style={{ marginTop: "60px" }}
                >
                  <span>IPTV Plans</span>
                  <h3>Your need. Your choice.</h3>
                </div>
              </div>
            </div>

            <div className="planstab">
              <div className="bundlestn">
                {plans.length > 0 ? (
                  plans.map((plan) => {
                    const features = plan.features
                      ? plan.features.split("|_")
                      : [];

                    return (
                      <div className="bundlebox" key={plan.sno}>
                        <h4
                          style={{ fontSize: "16px" }}
                          dangerouslySetInnerHTML={createMarkup(plan.pname)}
                        />
                        <div className="image_plans_div">
                          <div className="image_plan">
                            <img src={Plan_bg} alt="Plan" />
                          </div>

                          <p
                            dangerouslySetInnerHTML={createMarkup(plan.ptitle)}
                          />
                        </div>

                        {features.length > 0 && (
                          <ul>
                            {features.map((f, i) => (
                              <li
                                key={i}
                                dangerouslySetInnerHTML={createMarkup(f)}
                              />
                            ))}
                          </ul>
                        )}

                        <div className="price">
                          <h6>{plan.price}</h6>
                        </div>

                        {plan.icon_values && (
                          <div className="entertainment">
                            <Ottslider geticonValues={plan.icon_values} />
                          </div>
                        )}

                        <div className="buttnprop">
                          <Link to={`/book-now/${plan.plan_id}`}>
                            <span>Book Now</span>
                          </Link>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center">No Plan Found</p>
                )}
              </div>
            </div>
          </section>
        </div>
      </section>

      <Footer />
    </>
  );
};
